<template>
  <div class="chatbot-container novo-editor novo-editor--rete-canvas">
    <Toast position="top-right" />
    <Toast position="bottom-right" group="br" />
    <ModalConfiguracaoUsuario
      :usuario_config="usuario_config"
      :mostrar-alternancia-editor="true"
      :novo-editor-ativo="true"
      :alternancia-editor-desabilitada="!rascunhoPronto"
      @alternar-editor="trocarModoEditor"
    />
    <ModalEstagio />
    <ModalPresets
      :fluxoAtual="flowchartDataProperty"
      :tituloFluxo="tituloFluxo"
      :descricaoFluxo="descricaoFluxo"
      @confirmarPreset="substituirFluxoAtualPeloPreset"
    />
    <ModalAjudaEditorNovo :rete-canvas="usuario_config.use_rete_canvas" />
    <ModalCategoriasChatbot
      :categories="categories_chatbot_full_object"
      @refreshCategories="getCategories"
    />

    <header
      class="novo-editor__header"
      :class="{ 'novo-editor__header--with-draft': mostrarEstadoRascunho }"
    >
      <button
        class="novo-editor__back"
        type="button"
        title="Voltar para fluxos"
        @click="showModalConfirmacaoSair"
      >
        <i class="fas fa-arrow-left"></i>
      </button>
      <div class="novo-editor__heading">
        <span class="novo-editor__eyebrow"
          >CHATBOT / {{ modoEdicao ? "EDITAR FLUXO" : "NOVO FLUXO" }}</span
        >
        <h1>{{ tituloFluxo || "Fluxo sem título" }}</h1>
      </div>
      <span class="novo-editor__count"
        >{{ flowchartDataProperty.nodes.length }} estágios</span
      >
      <div class="novo-editor__header-actions">
        <div
          v-if="mostrarEstadoRascunho"
          class="novo-editor__draft-status"
          :class="`novo-editor__draft-status--${estadoRascunho.tipo}`"
          :title="estadoRascunho.detalhe"
          role="status"
          aria-live="polite"
        >
          <i :class="estadoRascunho.icone" aria-hidden="true"></i>
          <div class="novo-editor__draft-copy">
            <span>{{ estadoRascunho.rotulo }}</span>
            <small>{{ estadoRascunho.detalhe }}</small>
          </div>
        </div>
        <button
          class="novo-editor__button novo-editor__button--quiet"
          type="button"
          :aria-expanded="detalhesAbertos ? 'true' : 'false'"
          @click="detalhesAbertos = !detalhesAbertos"
        >
          <i class="fas fa-pen"></i> Dados do fluxo
        </button>
        <button
          class="novo-editor__button novo-editor__button--primary"
          type="button"
          @click="perguntarSalvarSair"
        >
          <i class="fas fa-save"></i> Salvar fluxo
        </button>
      </div>
    </header>

    <div ref="workspace" class="novo-editor__workspace">
      <main class="novo-editor__main">
        <div v-if="detalhesAbertos" class="novo-editor__details">
          <div class="novo-editor__field novo-editor__field--title">
            <label for="novo-fluxo-titulo">Título do fluxo</label>
            <b-form-input
              id="novo-fluxo-titulo"
              v-model="tituloFluxo"
              placeholder="Dê um nome ao fluxo"
            />
          </div>
          <div class="novo-editor__field novo-editor__field--description">
            <label for="novo-fluxo-descricao">Descrição</label>
            <b-form-input
              id="novo-fluxo-descricao"
              v-model="descricaoFluxo"
              placeholder="Descreva o objetivo do fluxo"
            />
          </div>
          <div class="novo-editor__field novo-editor__field--category">
            <label for="novo-fluxo-categorias">Categorias</label>
            <MultiSelect
              v-model="selected_categories"
              :options="categories_chatbot"
              optionLabel="name"
              inputId="novo-fluxo-categorias"
              display="chip"
              :filter="true"
              appendTo="body"
              placeholder="Selecionar"
              class="novo-editor__flow-categories"
            />
          </div>
          <button
            class="novo-editor__icon-button"
            type="button"
            title="Cadastrar categoria"
            aria-label="Cadastrar categoria"
            @click="openChatbotCategoryModal"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <div class="novo-editor__toolbar">
          <div class="novo-editor__toolbar-group">
            <button
              type="button"
              title="Desfazer"
              aria-label="Desfazer"
              @click="pegarDaStackFlowchartDataProperty"
            >
              <i class="fas fa-undo"></i>
            </button>
            <button
              type="button"
              title="Refazer"
              aria-label="Refazer"
              @click="pegarDaRedoStackFlowchartDataProperty"
            >
              <i class="fas fa-redo"></i>
            </button>
            <button
              ref="CenterFlowchartBtn"
              type="button"
              title="Centralizar"
              aria-label="Centralizar"
              @click="centerFlowchart"
            >
              <i class="fas fa-bullseye"></i>
            </button>
            <button
              type="button"
              title="Aumentar zoom"
              aria-label="Aumentar zoom"
              @click="zoomIn"
            >
              <i class="fas fa-plus"></i>
            </button>
            <button
              type="button"
              title="Diminuir zoom"
              aria-label="Diminuir zoom"
              @click="zoomOut"
            >
              <i class="fas fa-minus"></i>
            </button>
            <button
              class="novo-editor__toolbar-icon"
              type="button"
              title="Copiar fluxo"
              aria-label="Copiar fluxo"
              @click="copiarFluxo(false)"
            >
              <i class="far fa-copy"></i>
            </button>
            <button
              class="novo-editor__toolbar-icon"
              type="button"
              title="Colar fluxo"
              aria-label="Colar fluxo"
              @click="colarFluxo"
            >
              <i class="fas fa-paste"></i>
            </button>
            <button
              class="novo-editor__toolbar-icon"
              type="button"
              title="Formatar fluxo"
              aria-label="Formatar fluxo"
              @click="formatFlowchart"
            >
              <i class="fas fa-magic"></i>
            </button>
            <button
              class="novo-editor__toolbar-icon"
              type="button"
              :class="{ 'novo-editor__tool-button--active': modoSelecaoAtivo }"
              :aria-pressed="modoSelecaoAtivo ? 'true' : 'false'"
              title="Selecionar: arraste no canvas para marcar estágios"
              aria-label="Ativar seleção de estágios"
              @click="modoSelecaoAtivo = !modoSelecaoAtivo"
            >
              <i class="fas fa-mouse-pointer"></i>
            </button>
          </div>
          <div
            class="novo-editor__toolbar-group novo-editor__toolbar-group--end"
          >
            <button
              v-if="modoEdicao"
              class="novo-editor__test-trigger"
              type="button"
              :aria-pressed="painelTesteAberto ? 'true' : 'false'"
              @click="abrirPainelTeste"
            >
              <i
                :class="painelTesteAberto ? 'fas fa-times' : 'fas fa-play'"
                class="mr-2"
              ></i>
              {{ painelTesteAberto ? "Fechar teste" : "Testar fluxo" }}
            </button>
            <button
              type="button"
              title="Tela cheia"
              aria-label="Tela cheia"
              @click="toggleFullscreen"
            >
              <i class="fas fa-expand"></i>
            </button>
            <button
              type="button"
              title="Configurações"
              aria-label="Configurações"
              @click="showModalConfiguracoes"
            >
              <i class="fas fa-cog"></i>
            </button>
          </div>
        </div>

        <div
          ref="editorBody"
          class="novo-editor__editor-body"
          :class="{ 'novo-editor__editor-body--testing': painelTesteAberto }"
        >
          <aside
            v-if="painelTesteAberto"
            class="novo-editor__test-panel"
            aria-label="Conversa de teste do fluxo"
          >
            <div
              class="novo-editor__chat-slot"
              aria-label="Conversa de teste do fluxo"
            >
              <ChatwootTeste
                v-if="testeChatwoot"
                :conta-id="testeChatwoot.conta_id"
                :fluxo-id="testeChatwoot.fluxo_id"
                @ready="testePronto = true"
                @close="fecharPainelTeste"
                @error="erroTesteChatwoot"
              />
              <div v-if="!testePronto" class="novo-editor__chat-placeholder">
                <i class="far fa-comments"></i>
                <span>{{
                  testandoFluxo
                    ? "Preparando conversa de teste..."
                    : "Carregando conversa de teste..."
                }}</span>
              </div>
            </div>
          </aside>
          <aside
            ref="biblioteca"
            class="novo-editor__palette"
            :class="{ 'novo-editor__palette--closed': !bibliotecaAberta }"
            :style="{
              '--palette-width': larguraBiblioteca + 'px'
            }"
            :aria-hidden="bibliotecaAberta ? 'false' : 'true'"
            aria-label="Biblioteca de estágios"
          >
            <div class="novo-editor__palette-head">
              <div class="novo-editor__palette-title">
                <h2>Estágios</h2>
                <button
                  type="button"
                  aria-label="Fechar biblioteca de estágios"
                  title="Fechar biblioteca"
                  @click="bibliotecaAberta = false"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <p v-if="usuario_config.use_rete_canvas && posicaoInsercaoRete">
                Escolha um estágio para adicionar no ponto selecionado.
              </p>
              <p v-else>Arraste para o canvas ou clique para adicionar.</p>
            </div>
            <div class="novo-editor__palette-filters">
              <label class="novo-editor__search">
                <i class="fas fa-search"></i>
                <input
                  ref="buscaEstagioInput"
                  v-model="buscaEstagio"
                  type="search"
                  placeholder="Buscar estágio"
                  aria-label="Buscar estágio"
                  :role="usuario_config.use_rete_canvas ? 'combobox' : null"
                  :aria-autocomplete="
                    usuario_config.use_rete_canvas ? 'list' : null
                  "
                  :aria-controls="
                    usuario_config.use_rete_canvas ? 'rete-stage-results' : null
                  "
                  :aria-expanded="
                    usuario_config.use_rete_canvas
                      ? String(bibliotecaAberta)
                      : null
                  "
                  :aria-activedescendant="idEstagioBuscaAtivo"
                  @keydown="navegarBuscaEstagios"
                />
              </label>
              <pv-dropdown
                v-if="usuario_config.stages_by_category"
                v-model="chatbot_estagio_categoria_selecionada"
                :options="categorias"
                optionLabel="text"
                optionValue="value"
                :filter="true"
                inputId="novo-estagio-categoria"
                appendTo="body"
                placeholder="Todas as categorias"
                class="novo-editor__category-select"
              />
            </div>
            <div
              ref="listaEstagios"
              class="novo-editor__stage-list"
              :id="usuario_config.use_rete_canvas ? 'rete-stage-results' : null"
              :role="usuario_config.use_rete_canvas ? 'listbox' : null"
              :aria-label="
                usuario_config.use_rete_canvas ? 'Estágios encontrados' : null
              "
            >
              <button
                v-for="(estagio, indice) in estagiosVisiveis"
                :key="estagio.chatbot_estagio_id"
                class="novo-editor__stage"
                :class="{
                  'novo-editor__stage--highlighted':
                    usuario_config.use_rete_canvas &&
                    indice === indiceEstagioBusca
                }"
                :id="
                  usuario_config.use_rete_canvas
                    ? `rete-stage-option-${estagio.chatbot_estagio_id}`
                    : null
                "
                :role="usuario_config.use_rete_canvas ? 'option' : null"
                :aria-selected="
                  usuario_config.use_rete_canvas
                    ? String(indice === indiceEstagioBusca)
                    : null
                "
                :tabindex="usuario_config.use_rete_canvas ? -1 : null"
                type="button"
                draggable="true"
                :aria-label="`Adicionar estágio ${estagio.ces_nome}`"
                @dragstart="
                  iniciarArrasteEstagio($event, estagio.chatbot_estagio_id)
                "
                @dragend="arrastandoEstagio = false"
                @click="
                  adicionarEstagioDaBiblioteca(estagio.chatbot_estagio_id)
                "
              >
                <span
                  class="novo-editor__stage-mark"
                  :style="{ backgroundColor: estagio.cor || '#462181' }"
                ></span>
                <span>{{ estagio.ces_nome }}</span>
                <i class="fas fa-grip-vertical" aria-hidden="true"></i>
              </button>
              <p
                v-if="!estagiosVisiveis.length"
                class="novo-editor__empty-list"
              >
                Nenhum estágio encontrado.
              </p>
            </div>
            <div class="novo-editor__palette-footer">
              <button type="button" @click="mostrarModalPresets">
                <i class="fas fa-layer-group"></i> Usar template
              </button>
              <button type="button" @click="abrirModalAjudaFluxo">
                <i class="far fa-question-circle"></i> Ajuda do editor
              </button>
            </div>
            <div
              v-if="bibliotecaAberta && larguraMaxima > larguraMinima"
              class="novo-editor__resize-handle"
              role="separator"
              tabindex="0"
              aria-label="Ajustar largura da biblioteca de estágios"
              aria-orientation="vertical"
              :aria-valuemin="larguraMinima"
              :aria-valuemax="larguraMaxima"
              :aria-valuenow="larguraBiblioteca"
              title="Arraste para ajustar a largura"
              @pointerdown="iniciarRedimensionamento"
              @keydown.left.prevent="ajustarLarguraBiblioteca(-20)"
              @keydown.right.prevent="ajustarLarguraBiblioteca(20)"
            >
              <span></span>
            </div>
          </aside>
          <div
            ref="canvas"
            class="novo-editor__canvas fluxo-container"
            :class="{
              'novo-editor__canvas--drop': arrastandoEstagio,
              'novo-editor__canvas--selection-mode': modoSelecaoAtivo
            }"
            @mousedown.capture="iniciarSelecaoEstagios"
            @dragover.prevent="permitirSoltarEstagio"
            @drop.prevent.stop="soltarEstagio"
          >
            <div
              v-if="caixaSelecaoEstagios"
              class="novo-editor__selection-box"
              :style="{
                left: caixaSelecaoEstagios.x + 'px',
                top: caixaSelecaoEstagios.y + 'px',
                width: caixaSelecaoEstagios.largura + 'px',
                height: caixaSelecaoEstagios.altura + 'px'
              }"
            ></div>
            <button
              v-if="!bibliotecaAberta"
              class="novo-editor__open-palette"
              type="button"
              aria-label="Abrir biblioteca de estágios"
              @click.stop="abrirBiblioteca"
            >
              <span class="novo-editor__open-palette-icon"
                ><i class="fas fa-plus"></i
              ></span>
              <span class="novo-editor__open-palette-label">Novo estágio</span>
              <i
                class="fas fa-chevron-right novo-editor__open-palette-chevron"
              ></i>
            </button>
            <div
              v-if="!flowchartDataProperty.nodes.length && !arrastandoEstagio"
              class="novo-editor__canvas-hint"
            >
              <i class="fas fa-project-diagram"></i>
              <strong>Comece pelo primeiro estágio</strong>
              <span>Arraste um estágio da biblioteca para cá.</span>
            </div>
            <div v-if="arrastandoEstagio" class="novo-editor__drop-hint">
              Solte para adicionar o estágio neste ponto
            </div>
            <ReteFlowCanvas
              ref="reteCanvas"
              :scene="flowchartDataProperty"
              :flow-id="identificadorFluxoRete()"
              :ready="rascunhoPronto"
              :selection-mode="modoSelecaoAtivo"
              :field-options="opcoesCamposRete"
              @copy-debug-log="copiarLogRete"
              @selection-change="selecionarNoCanvasRete"
              @node-options="abrirOpcoesEstagioRete"
              @canvas-click="fecharOpcoesEstagioRete"
              @canvas-contextmenu="abrirMenuCanvasRete"
              @connection-added="adicionarConexaoRete"
              @connection-removed="linkBreak"
              @connection-rejected="avisarLigacaoReteRejeitada"
              @delete-error="erroAoRemoverEstagiosRete"
              @add-connected-stage="abrirBibliotecaParaConectarRete"
              @node-moved="reposicionarOpcoesEstagio"
              @viewport-change="reposicionarOpcoesEstagio"
            />
          </div>
          <ReteCanvasMenu
            v-if="menuCanvasRete"
            :position="menuCanvasRete"
            @close="menuCanvasRete = null"
            @add="abrirBibliotecaNoPonto"
            @remove-link="apagarLinkRete"
            @search="buscarEstagioRete"
          />
          <component
            :is="
              usuario_config.use_rete_canvas
                ? 'ReteStageOptions'
                : 'SidebarFluxo'
            "
            :embedded="true"
            :modern-editor="usuario_config.use_rete_canvas"
            :panel-style="
              usuario_config.use_rete_canvas ? opcoesEstagioStyle : {}
            "
            ref="stageOptions"
            :isVisible="sidebarVisible"
            :activeNode="activeNode"
            :sistemas="sistemas"
            :childrens="childrens"
            :modelos="chatbotModelos"
            :times="times"
            :caixasEntrada="caixasEntrada"
            :temRecursoWidgetSite="possuiRecursoWidgetSite()"
            :marcadores="marcadores"
            :atributos_customizaveis="custom_attributes"
            :agendas="agendas"
            :opcoesFormatacaoEntrada="opcoesFormatacaoEntrada"
            :estagiosPai="estagiosPai"
            :variaveisDeclaradas="variaveisDeclaradas"
            :modeloLinks="modeloLinks"
            :chatbotCallbacks="chatbotCallbacks"
            :fluxosDeChatbot="fluxosDeChatbot"
            :prioridades="prioridades"
            :tipo_reagendamento="tipo_reagendamento"
            :tipo_req_http="tipo_req_http"
            :tipo_arquivo="tipo_arquivo"
            :select_orientacao="select_orientacao"
            @abrirModalInformacoesEstagio="abrirModalInformacoesEstagio"
            @fechar="sidebarVisible = false"
          />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import CadastroFluxo from "./CadastroFluxo.vue";
import ChatwootTeste from "./ChatwootTeste.vue";
import ReteFlowCanvas from "./ReteFlowCanvas.vue";
import ReteStageOptions from "./ReteStageOptions.vue";
import ReteCanvasMenu from "./ReteCanvasMenu.vue";
import ModalAjudaEditorNovo from "./ModalAjudaEditorNovo.vue";
import { exportReteDebugLog, recordReteDebug } from "./reteDebugLog";

export default {
  name: "CadastroFluxoNovo",
  extends: CadastroFluxo,
  components: {
    ChatwootTeste,
    ReteFlowCanvas,
    ReteStageOptions,
    ReteCanvasMenu,
    ModalAjudaEditorNovo
  },
  data() {
    return {
      usuario_config: { use_rete_canvas: true, editor_novo: true },
      buscaEstagio: "",
      indiceEstagioBusca: 0,
      menuCanvasRete: null,
      posicaoInsercaoRete: null,
      estagioDecisaoOrigemId: null,
      detalhesAbertos: false,
      arrastandoEstagio: false,
      bibliotecaAberta: false,
      painelTesteAberto: false,
      testandoFluxo: false,
      testePronto: false,
      testeChatwoot: null,
      larguraTemporaria: null,
      larguraArea: window.innerWidth,
      estagiosSelecionados: [],
      caixaSelecaoEstagios: null,
      modoSelecaoAtivo: false,
      reteDecisionBranchIndex: null,
      reteDecisionBranchReutilizada: false,
      opcoesEstagioStyle: {}
    };
  },
  mounted() {
    const widgetEmCarregamento = document.querySelector(
      'script[src*="chat.wellon.digital/packs/js/sdk.js"]'
    );
    if (!window.$chatwoot && !widgetEmCarregamento) {
      window.chatwootLaunchForSupport();
    }
    this.atualizarLarguraArea();
    this.$nextTick(this.configurarMovimentoEmGrupo);
    window.addEventListener("resize", this.atualizarLarguraArea);
    window.addEventListener("error", this.registrarErroGlobalRete);
    window.addEventListener(
      "unhandledrejection",
      this.registrarRejeicaoGlobalRete
    );
    document.addEventListener("click", this.fecharBibliotecaAoClicarFora);
    document.addEventListener("keydown", this.aoTeclarAtalhoRete, true);
    this.registrarDiagnosticoRete("editor.mounted", {
      userAgent: navigator.userAgent,
      locale: navigator.language,
      viewport: { width: window.innerWidth, height: window.innerHeight }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.atualizarLarguraArea);
    window.removeEventListener("error", this.registrarErroGlobalRete);
    window.removeEventListener(
      "unhandledrejection",
      this.registrarRejeicaoGlobalRete
    );
    document.removeEventListener("click", this.fecharBibliotecaAoClicarFora);
    document.removeEventListener("keydown", this.aoTeclarAtalhoRete, true);
    document.removeEventListener(
      "mousemove",
      this.atualizarCaixaSelecaoEstagios
    );
    document.removeEventListener("mouseup", this.finalizarSelecaoEstagios);
    this.encerrarRedimensionamento();
  },
  errorCaptured(error, vm, info) {
    this.registrarDiagnosticoRete("vue.error_captured", {
      message: error?.message,
      stack: error?.stack,
      component: vm?.$options?.name || vm?.$options?._componentTag || null,
      info
    });
  },
  watch: {
    estagiosVisiveis() {
      this.indiceEstagioBusca = 0;
      if (this.usuario_config.use_rete_canvas && this.bibliotecaAberta)
        this.rolarEstagioBuscaAtivo();
    },
    bibliotecaAberta(aberta) {
      if (!aberta) {
        this.posicaoInsercaoRete = null;
        this.estagioDecisaoOrigemId = null;
      }
    }
  },
  methods: {
    abrirModalAjudaFluxo() {
      this.$modal.show("modal-ajuda-editor-novo");
    },
    identificadorFluxoRete() {
      return (
        this.$route?.query?.fluxo_id ||
        this.$route?.params?.fluxo_id ||
        this.$route?.params?.id ||
        this.flowchartDataProperty?.id ||
        null
      );
    },
    registrarDiagnosticoRete(event, details = {}) {
      recordReteDebug(event, {
        flowId: this.identificadorFluxoRete(),
        ...details
      });
    },
    registrarErroGlobalRete(event) {
      this.registrarDiagnosticoRete("window.error", {
        message: event.message,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
        stack: event.error?.stack
      });
    },
    registrarRejeicaoGlobalRete(event) {
      const reason = event.reason;
      this.registrarDiagnosticoRete("window.unhandled_rejection", {
        reason:
          reason instanceof Error
            ? {
                name: reason.name,
                message: reason.message,
                stack: reason.stack
              }
            : String(reason)
      });
    },
    async copiarLogRete() {
      const log = exportReteDebugLog();
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(log);
        } else {
          const campo = document.createElement("textarea");
          campo.value = log;
          campo.setAttribute("readonly", "");
          campo.style.position = "fixed";
          campo.style.opacity = "0";
          document.body.appendChild(campo);
          campo.select();
          const copiou = document.execCommand("copy");
          campo.remove();
          if (!copiou) throw new Error("O navegador recusou a cópia.");
        }
        this.$toast.add({
          severity: "success",
          summary: "Log copiado",
          detail: "Envie o conteúdo copiado para o time de desenvolvimento.",
          life: 4000
        });
      } catch (error) {
        this.registrarDiagnosticoRete("debug.copy_failed", {
          message: error?.message,
          stack: error?.stack
        });
        this.$toast.add({
          severity: "error",
          summary: "Não foi possível copiar o log",
          detail: "Tente novamente neste navegador.",
          life: 4000
        });
      }
    },
    aoTeclarAtalhoRete(event) {
      if (!this.usuario_config.use_rete_canvas || event.isComposing) return;

      const tecla = event.key.toLowerCase();
      const elemento = event.target;
      const digitando = Boolean(
        elemento?.closest?.(
          "input, textarea, select, [contenteditable='true'], .p-dropdown, .p-multiselect"
        )
      );

      if (event.key === "Escape") {
        if (this.menuCanvasRete) {
          event.preventDefault();
          event.stopPropagation();
          this.menuCanvasRete = null;
          return;
        }
        if (this.bibliotecaAberta) {
          event.preventDefault();
          event.stopPropagation();
          this.bibliotecaAberta = false;
          return;
        }
        if (this.$refs.reteCanvas?.searchOpen) {
          event.preventDefault();
          event.stopPropagation();
          this.$refs.reteCanvas.fecharBusca();
          return;
        }
        if (!digitando) {
          event.preventDefault();
          event.stopPropagation();
          this.$refs.reteCanvas?.clearSelection();
          this.estagiosSelecionados = [];
          this.sidebarVisible = false;
          this.activeNode = {};
        }
        return;
      }

      if (digitando || event.altKey || event.ctrlKey || event.metaKey) return;

      if (tecla === "f" && !event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        this.menuCanvasRete = null;
        this.bibliotecaAberta = false;
        this.$refs.reteCanvas?.abrirBusca();
        return;
      }

      if (tecla === "a") {
        event.preventDefault();
        event.stopPropagation();
        this.menuCanvasRete = null;
        if (event.shiftKey) {
          if (this.estagiosSelecionados.length !== 1) return;
          const origemId = this.estagiosSelecionados[0];
          const origem = this.flowchartDataProperty.nodes.find(
            (node) => String(node.id) === String(origemId)
          );
          if (!origem) return;
          const erro = this.$refs.reteCanvas?.validarNovaSaida(origem.id);
          if (erro) {
            this.avisarLigacaoReteRejeitada(erro);
            return;
          }
          this.abrirBibliotecaParaConectarRete(origem.id);
        } else {
          this.buscaEstagio = "";
          this.abrirBiblioteca();
        }
        return;
      }

      if (!event.shiftKey && tecla === "0") {
        event.preventDefault();
        event.stopPropagation();
        this.$refs.reteCanvas?.centralizar();
        return;
      }

      if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        event.stopPropagation();
        this.$refs.reteCanvas?.zoomIn();
      } else if (event.key === "-") {
        event.preventDefault();
        event.stopPropagation();
        this.$refs.reteCanvas?.zoomOut();
      }
    },
    reposicionarOpcoesEstagio() {
      if (!this.usuario_config.use_rete_canvas || !this.sidebarVisible) return;
      this.$nextTick(() => {
        const nodeId = this.activeNode?.id;
        const body = this.$refs.editorBody;
        const nodeElement = this.$refs.reteCanvas?.getNodeElement(nodeId);
        const panel = this.$refs.stageOptions?.$el;
        if (!body || !nodeElement || !panel) return;
        const bodyRect = body.getBoundingClientRect();
        const nodeRect = nodeElement.getBoundingClientRect();
        const panelWidth = Math.min(panel.offsetWidth || 380, 420);
        const panelHeight = panel.offsetHeight || bodyRect.height - 24;
        const margin = 12;
        const spaceRight = bodyRect.right - nodeRect.right;
        let left =
          spaceRight >= panelWidth + margin * 2
            ? nodeRect.right + margin
            : nodeRect.left - panelWidth - margin;
        left = Math.max(
          bodyRect.left + margin,
          Math.min(left, bodyRect.right - panelWidth - margin)
        );
        const top = Math.max(
          bodyRect.top + margin,
          Math.min(nodeRect.top, bodyRect.bottom - panelHeight - margin)
        );
        this.opcoesEstagioStyle = {
          boxSizing: "border-box",
          bottom: "auto",
          display: "block",
          height: "auto",
          left: `${left}px`,
          maxHeight: `${Math.max(180, bodyRect.height - margin * 2)}px`,
          minWidth: "0",
          overflowY: "auto",
          padding: "0",
          position: "fixed",
          right: "auto",
          top: `${top}px`,
          width: `${Math.min(420, bodyRect.width - margin * 2)}px`,
          zIndex: 3000
        };
      });
    },
    selecionarNoCanvasRete(ids, idClicado) {
      const nodeClicado = this.flowchartDataProperty.nodes.find(
        (item) => String(item.id) === String(idClicado)
      );
      const selecao = this._modificadorSelecaoAtivo
        ? ids
        : nodeClicado
        ? [nodeClicado.id]
        : ids;
      this._modificadorSelecaoAtivo = false;
      this.estagiosSelecionados = selecao;
      if (selecao.length > 1) {
        this.sidebarVisible = false;
        this.activeNode = {};
      } else if (
        selecao.length === 1 &&
        this.sidebarVisible &&
        String(this.activeNode?.id) !== String(selecao[0])
      ) {
        this.sidebarVisible = false;
        this.activeNode = {};
      }
    },
    fecharOpcoesEstagioRete() {
      this.sidebarVisible = false;
      this.activeNode = {};
    },
    abrirOpcoesEstagioRete(id) {
      const node = this.flowchartDataProperty.nodes.find(
        (item) => String(item.id) === String(id)
      );
      if (!node) return;
      this._modificadorSelecaoAtivo = false;
      this.estagiosSelecionados = [node.id];
      CadastroFluxo.methods.nodeClick.call(this, node.id);
      this.opcoesEstagioStyle = {
        boxSizing: "border-box",
        height: "auto",
        left: "12px",
        maxHeight: "calc(100vh - 24px)",
        overflowY: "auto",
        position: "fixed",
        top: "12px",
        width: "min(420px, calc(100vw - 24px))",
        zIndex: 3000
      };
      this.sidebarVisible = true;
      this.reposicionarOpcoesEstagio();
    },
    adicionarConexaoRete(link, outputKey) {
      const origem = this.flowchartDataProperty.nodes.find(
        (item) => String(item.id) === String(link.from)
      );
      this.registrarDiagnosticoRete("parent.connection_added", {
        linkId: link.id,
        sourceNodeId: link.from,
        targetNodeId: link.to,
        sourceStageType: origem?.chatbot_estagio_id,
        sourceOutput: outputKey
      });
      this.reteDecisionBranchReutilizada = false;
      this.reteDecisionBranchIndex = null;
      if (Number(origem?.chatbot_estagio_id) === 10) {
        const branchKey = String(outputKey);
        const branches = (origem.ces_metadata?.campos || []).filter((grupo) =>
          Array.isArray(grupo)
        );
        const branchIndex = branchKey.startsWith("branch-to-")
          ? branches.findIndex(
              (group) =>
                String(
                  group.find(
                    (field) =>
                      field.bindText === "para_chatbot_fluxo_estagio_id"
                  )?.value
                ) === branchKey.replace("branch-to-", "")
            )
          : branchKey === "branch-new"
          ? branches.findIndex(
              (group) =>
                group.find(
                  (field) => field.bindText === "para_chatbot_fluxo_estagio_id"
                )?.value == null
            )
          : Number(branchKey.replace("branch-", ""));
        if (
          Number.isInteger(branchIndex) &&
          branchIndex >= 0 &&
          branchIndex < branches.length
        ) {
          this.reteDecisionBranchReutilizada = true;
          this.reteDecisionBranchIndex = branchIndex;
          ["para_chatbot_fluxo_estagio_id", "cec_ordem"].forEach((bindText) => {
            const campo = branches[branchIndex].find(
              (item) => item.bindText === bindText
            );
            if (campo) campo.value = link.to;
          });
        }
      }
      this.linkAdded(link);
      this.$nextTick(() => {
        this.reteDecisionBranchReutilizada = false;
        this.reteDecisionBranchIndex = null;
      });
    },
    avisarLigacaoReteRejeitada(mensagem) {
      this.registrarDiagnosticoRete("parent.connection_rejected", {
        reason: mensagem
      });
      this.$toast.add({
        severity: "warn",
        summary: "Ligação não permitida",
        detail: mensagem,
        life: 4500
      });
    },
    pegarDaStackFlowchartDataProperty() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.desfazer();
        return;
      }
      return CadastroFluxo.methods.pegarDaStackFlowchartDataProperty.call(this);
    },
    pegarDaRedoStackFlowchartDataProperty() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.refazer();
        return;
      }
      return CadastroFluxo.methods.pegarDaRedoStackFlowchartDataProperty.call(
        this
      );
    },
    centerFlowchart() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.centralizar();
        return;
      }
      return CadastroFluxo.methods.centerFlowchart.call(this);
    },
    zoomIn() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.zoomIn();
        return;
      }
      return CadastroFluxo.methods.zoomIn.call(this);
    },
    zoomOut() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.zoomOut();
        return;
      }
      return CadastroFluxo.methods.zoomOut.call(this);
    },
    formatFlowchart() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.formatar();
        return;
      }
      return CadastroFluxo.methods.formatFlowchart.call(this);
    },
    removerNodeAtivo() {
      if (this.usuario_config.use_rete_canvas) {
        this.$refs.reteCanvas?.removerSelecionados();
        return;
      }
      return CadastroFluxo.methods.removerNodeAtivo.call(this);
    },
    duplicateActiveNode() {
      const id = this.estagiosSelecionados[0];
      const stage = this.flowchartDataProperty.nodes.find(
        (item) => String(item.id) === String(id)
      );
      if (!stage) return;
      const clone = JSON.parse(JSON.stringify(stage));
      delete clone.chatbot_fluxo_estagio_id;
      delete clone.chatbot_fluxo_id;
      clone.id = this.initial_id++;
      clone.label = `${clone.label} - Cópia`;
      clone.type = `${clone.type} - Cópia`;
      clone.x = (Number(clone.x) || 0) + 60;
      clone.y = (Number(clone.y) || 0) + 60;
      if (Number(clone.chatbot_estagio_id) === 10) {
        clone.ces_metadata.campos.flat().forEach((field) => {
          if (
            ["para_chatbot_fluxo_estagio_id", "cec_ordem"].includes(
              field.bindText
            )
          )
            field.value = null;
        });
      }
      this.flowchartDataProperty.nodes.push(clone);
    },
    moveFlowchartUp() {
      this.$refs.reteCanvas?.deslocar(0, 100);
    },
    moveFlowchartDown() {
      this.$refs.reteCanvas?.deslocar(0, -100);
    },
    moveFlowchartLeft() {
      this.$refs.reteCanvas?.deslocar(100, 0);
    },
    moveFlowchartRight() {
      this.$refs.reteCanvas?.deslocar(-100, 0);
    },
    erroAoRemoverEstagiosRete(error) {
      console.error("Erro ao remover estágios selecionados:", error);
      this.$toast.add({
        severity: "error",
        summary: "Não foi possível remover todos os estágios",
        detail: "Tente novamente.",
        life: 5000
      });
    },
    nodeClick(nodeId) {
      const combinacao = this._modificadorSelecaoAtivo;
      this._naoAbrirOpcoesNesteClique = combinacao;
      if (combinacao) {
        this.estagiosSelecionados = this.estagiosSelecionados.includes(nodeId)
          ? this.estagiosSelecionados.filter((id) => id !== nodeId)
          : [...this.estagiosSelecionados, nodeId];
      } else if (!this.estagiosSelecionados.includes(nodeId)) {
        this.estagiosSelecionados = [nodeId];
      } else if (this.estagiosSelecionados.length > 1) {
        this._naoAbrirOpcoesNesteClique = true;
      }
      this._modificadorSelecaoAtivo = false;
      this.atualizarDestaqueEstagiosSelecionados();
      CadastroFluxo.methods.nodeClick.call(this, nodeId);
    },
    canvasClick(event) {
      if (
        !event.target.closest?.(".flowchart-node") &&
        !this._naoAbrirOpcoesNesteClique
      ) {
        this.estagiosSelecionados = [];
        this.atualizarDestaqueEstagiosSelecionados();
      }
      if (
        this.estagiosSelecionados.length > 1 ||
        this._naoAbrirOpcoesNesteClique
      ) {
        this.sidebarVisible = false;
      } else {
        CadastroFluxo.methods.canvasClick.call(this, event);
      }
      this._naoAbrirOpcoesNesteClique = false;
    },
    atualizarDestaqueEstagiosSelecionados() {
      if (this.usuario_config.use_rete_canvas) return;
      this.$nextTick(() => {
        this.$refs.canvas
          ?.querySelectorAll(".flowchart-node")
          .forEach((elemento, index) => {
            elemento.classList.toggle(
              "node-group-selected",
              this.estagiosSelecionados.includes(
                this.flowchartDataProperty.nodes[index]?.id
              )
            );
          });
      });
    },
    configurarMovimentoEmGrupo() {
      const instancia = this.$refs.flowchart;
      if (!instancia || instancia._movimentoEmGrupoConfigurado) return;
      const moverOriginal = instancia.moveSelectedNode.bind(instancia);
      instancia.moveSelectedNode = (dx, dy) => {
        const ids = this.estagiosSelecionados;
        if (ids.length < 2 || !ids.includes(instancia.action.dragging)) {
          moverOriginal(dx, dy);
          return;
        }
        const escala = this.flowchartDataProperty.scale || 1;
        this.flowchartDataProperty.nodes.forEach((node) => {
          if (ids.includes(node.id)) {
            node.x += dx / escala;
            node.y += dy / escala;
          }
        });
      };
      instancia._movimentoEmGrupoConfigurado = true;
    },
    iniciarSelecaoEstagios(event) {
      const clicouNoEstagio = Boolean(
        event.target.closest?.(".flowchart-node, .rete-stage-node")
      );
      this._modificadorSelecaoAtivo =
        clicouNoEstagio && (event.shiftKey || event.ctrlKey || event.metaKey);
      if (
        !this.modoSelecaoAtivo ||
        event.button !== 0 ||
        event.target.closest?.(".flowchart-node, .rete-stage-node, button")
      )
        return;
      const bounds = this.$refs.canvas.getBoundingClientRect();
      const x = event.clientX - bounds.left;
      const y = event.clientY - bounds.top;
      this.caixaSelecaoEstagios = { x, y, largura: 0, altura: 0 };
      this._inicioSelecaoEstagios = { x, y, bounds };
      this._selecaoAditivaAtiva =
        event.shiftKey || event.ctrlKey || event.metaKey;
      this._selecaoInicialEstagios = this._selecaoAditivaAtiva
        ? [...this.estagiosSelecionados]
        : [];
      this._movendoCaixaSelecaoEstagios = false;
      this.sidebarVisible = false;
      document.addEventListener(
        "mousemove",
        this.atualizarCaixaSelecaoEstagios
      );
      document.addEventListener("mouseup", this.finalizarSelecaoEstagios);
      event.preventDefault();
      event.stopPropagation();
    },
    atualizarCaixaSelecaoEstagios(event) {
      if (!this._inicioSelecaoEstagios) return;
      const { x, y, bounds } = this._inicioSelecaoEstagios;
      const atualX = Math.max(
        0,
        Math.min(bounds.width, event.clientX - bounds.left)
      );
      const atualY = Math.max(
        0,
        Math.min(bounds.height, event.clientY - bounds.top)
      );
      if (Math.abs(atualX - x) + Math.abs(atualY - y) > 4)
        this._movendoCaixaSelecaoEstagios = true;
      this.caixaSelecaoEstagios = {
        x: Math.min(x, atualX),
        y: Math.min(y, atualY),
        largura: Math.abs(atualX - x),
        altura: Math.abs(atualY - y)
      };
    },
    finalizarSelecaoEstagios() {
      if (!this._inicioSelecaoEstagios) return;
      if (this._movendoCaixaSelecaoEstagios) {
        const caixa = this.caixaSelecaoEstagios;
        if (this.usuario_config.use_rete_canvas) {
          const boundsCanvas = this.$refs.canvas.getBoundingClientRect();
          this.$refs.reteCanvas?.selectNodesInRect(
            {
              left: boundsCanvas.left + caixa.x,
              top: boundsCanvas.top + caixa.y,
              right: boundsCanvas.left + caixa.x + caixa.largura,
              bottom: boundsCanvas.top + caixa.y + caixa.altura
            },
            this._selecaoAditivaAtiva
          );
          this.estagiosSelecionados = this._selecaoInicialEstagios;
          return this.finalizarSelecaoEstagiosRete();
        }
        const selecao = this.$refs.canvas.querySelectorAll(".flowchart-node");
        const boundsCanvas = this.$refs.canvas.getBoundingClientRect();
        const idsSelecionados = Array.from(selecao)
          .filter((elemento) => {
            const rect = elemento.getBoundingClientRect();
            const left = rect.left - boundsCanvas.left;
            const top = rect.top - boundsCanvas.top;
            return (
              left < caixa.x + caixa.largura &&
              left + rect.width > caixa.x &&
              top < caixa.y + caixa.altura &&
              top + rect.height > caixa.y
            );
          })
          .map(
            (elemento) =>
              this.flowchartDataProperty.nodes[
                Array.from(selecao).indexOf(elemento)
              ]?.id
          )
          .filter((id) => id !== undefined);
        this.estagiosSelecionados = this._selecaoAditivaAtiva
          ? [...new Set([...this._selecaoInicialEstagios, ...idsSelecionados])]
          : idsSelecionados;
        if (this.estagiosSelecionados.length > 1) this.sidebarVisible = false;
        this.atualizarDestaqueEstagiosSelecionados();
      } else {
        this.estagiosSelecionados = [];
        this.atualizarDestaqueEstagiosSelecionados();
      }
      this.caixaSelecaoEstagios = null;
      this._inicioSelecaoEstagios = null;
      this._movendoCaixaSelecaoEstagios = false;
      this._selecaoInicialEstagios = [];
      this._selecaoAditivaAtiva = false;
      this._modificadorSelecaoAtivo = false;
      document.removeEventListener(
        "mousemove",
        this.atualizarCaixaSelecaoEstagios
      );
      document.removeEventListener("mouseup", this.finalizarSelecaoEstagios);
    },
    finalizarSelecaoEstagiosRete() {
      this.caixaSelecaoEstagios = null;
      this._inicioSelecaoEstagios = null;
      this._movendoCaixaSelecaoEstagios = false;
      this._selecaoInicialEstagios = [];
      this._selecaoAditivaAtiva = false;
      this._modificadorSelecaoAtivo = false;
      document.removeEventListener(
        "mousemove",
        this.atualizarCaixaSelecaoEstagios
      );
      document.removeEventListener("mouseup", this.finalizarSelecaoEstagios);
    },
    async abrirPainelTeste() {
      if (this.painelTesteAberto) {
        this.fecharPainelTeste();
        return;
      }
      this.bibliotecaAberta = false;
      this.painelTesteAberto = true;
      await this.$nextTick();
      await this.executarTesteFluxo();
    },
    abrirMenuCanvasRete(context) {
      this.menuCanvasRete = {
        left: Math.max(8, Math.min(context.clientX, window.innerWidth - 242)),
        top: Math.max(8, Math.min(context.clientY, window.innerHeight - 120)),
        position: { ...context.position },
        connectionId: context.connectionId || null
      };
    },
    buscarEstagioRete() {
      this.menuCanvasRete = null;
      this.$refs.reteCanvas?.abrirBusca();
    },
    async apagarLinkRete(connectionId) {
      this.menuCanvasRete = null;
      await this.$refs.reteCanvas?.removerConexao(connectionId);
    },
    abrirBibliotecaNoPonto() {
      const position = this.menuCanvasRete?.position;
      if (!position) return;
      this.buscaEstagio = "";
      this.chatbot_estagio_categoria_selecionada = null;
      this.abrirBiblioteca();
      this.posicaoInsercaoRete = position;
      this.menuCanvasRete = null;
    },
    abrirBibliotecaParaConectarRete(origemId) {
      const origem = this.flowchartDataProperty.nodes.find(
        (item) => String(item.id) === String(origemId)
      );
      if (!origem) return;
      this.estagioDecisaoOrigemId = origem.id;
      this.$nextTick(() => {
        if (this.estagioDecisaoOrigemId !== origem.id) return;
        this.buscaEstagio = "";
        this.chatbot_estagio_categoria_selecionada = null;
        this.abrirBiblioteca();
        this.posicaoInsercaoRete = {
          x: (Number(origem.x) || 0) + 430,
          y: Number(origem.y) || 0
        };
      });
    },
    navegarBuscaEstagios(event) {
      if (
        !this.usuario_config.use_rete_canvas ||
        event.isComposing ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey
      )
        return;
      if (!["ArrowDown", "ArrowUp", "Enter"].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      const quantidade = this.estagiosVisiveis.length;
      if (!quantidade) return;
      if (event.key === "Enter") {
        const estagio = this.estagiosVisiveis[this.indiceEstagioBusca];
        if (estagio)
          this.adicionarEstagioDaBiblioteca(estagio.chatbot_estagio_id);
        return;
      }
      const passo = event.key === "ArrowDown" ? 1 : -1;
      this.indiceEstagioBusca =
        (this.indiceEstagioBusca + passo + quantidade) % quantidade;
      this.rolarEstagioBuscaAtivo();
    },
    rolarEstagioBuscaAtivo() {
      this.$nextTick(() => {
        const lista = this.$refs.listaEstagios;
        const item = lista?.querySelectorAll(".novo-editor__stage")[
          this.indiceEstagioBusca
        ];
        if (!item) return;
        const bounds = lista.getBoundingClientRect();
        const itemBounds = item.getBoundingClientRect();
        if (itemBounds.top < bounds.top)
          lista.scrollTop += itemBounds.top - bounds.top;
        else if (itemBounds.bottom > bounds.bottom)
          lista.scrollTop += itemBounds.bottom - bounds.bottom;
      });
    },
    abrirBiblioteca() {
      this.posicaoInsercaoRete = null;
      this.indiceEstagioBusca = 0;
      if (this.larguraArea < 720) this.sidebarVisible = false;
      this.bibliotecaAberta = true;
      if (this.usuario_config.use_rete_canvas) {
        this.$nextTick(() => {
          this.$refs.buscaEstagioInput?.focus({ preventScroll: true });
          this.$refs.buscaEstagioInput?.select();
        });
      }
    },
    fecharBibliotecaAoClicarFora(event) {
      if (!this.bibliotecaAberta) return;
      if (this.$refs.biblioteca?.contains(event.target)) return;
      if (event.target.closest?.(".p-dropdown-panel")) return;
      this.bibliotecaAberta = false;
    },
    fecharPainelTeste() {
      this.testeChatwoot = null;
      this.painelTesteAberto = false;
      this.testePronto = false;
      this.fluxo_teste_id = null;
    },
    erroTesteChatwoot(error) {
      this.fecharPainelTeste();
      this.$toast.add({
        severity: "error",
        summary: "Não foi possível iniciar o teste",
        detail: error?.message || "O Chatwoot não respondeu. Tente novamente.",
        life: 5000
      });
    },
    async executarTesteFluxo() {
      if (this.testandoFluxo) return;
      this.testandoFluxo = true;
      this.testePronto = false;
      this.fluxo_teste_id = null;
      try {
        await this.salvarFluxo(false, true);
        if (!this.painelTesteAberto) return;
        if (!this.fluxo_teste_id) {
          this.fecharPainelTeste();
          return;
        }
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        if (!usuario?.conta_id)
          throw new Error(
            "Não foi possível identificar a conta para iniciar o teste."
          );
        this.testeChatwoot = {
          conta_id: usuario.conta_id,
          fluxo_id: this.fluxo_teste_id
        };
      } catch (error) {
        if (this.painelTesteAberto) {
          this.fecharPainelTeste();
          this.$toast.add({
            severity: "error",
            summary: "Não foi possível iniciar o teste",
            detail: error.message || "Revise o fluxo e tente novamente.",
            life: 5000
          });
        }
      } finally {
        this.testandoFluxo = false;
      }
    },
    atualizarLarguraArea() {
      if (this.$refs.workspace) {
        this.larguraArea = this.$refs.workspace.clientWidth;
      }
      if (this.usuario_config.use_rete_canvas) {
        this.reposicionarOpcoesEstagio();
      }
    },
    limitarLarguraBiblioteca(largura) {
      return Math.max(
        this.larguraMinima,
        Math.min(this.larguraMaxima, largura)
      );
    },
    ajustarLarguraBiblioteca(diferenca) {
      this.usuario_config.stage_palette_width = this.limitarLarguraBiblioteca(
        this.larguraBiblioteca + diferenca
      );
    },
    iniciarRedimensionamento(event) {
      if (event.button !== 0) return;
      event.preventDefault();
      this._inicioXBiblioteca = event.clientX;
      this._larguraInicialBiblioteca = this.larguraBiblioteca;
      this.larguraTemporaria = this.larguraBiblioteca;
      this._cursorAnterior = document.body.style.cursor;
      this._selecaoAnterior = document.body.style.userSelect;
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
      window.addEventListener("pointermove", this.redimensionarBiblioteca);
      window.addEventListener("pointerup", this.encerrarRedimensionamento);
      window.addEventListener("pointercancel", this.encerrarRedimensionamento);
    },
    redimensionarBiblioteca(event) {
      this.larguraTemporaria = this.limitarLarguraBiblioteca(
        this._larguraInicialBiblioteca + event.clientX - this._inicioXBiblioteca
      );
    },
    encerrarRedimensionamento() {
      window.removeEventListener("pointermove", this.redimensionarBiblioteca);
      window.removeEventListener("pointerup", this.encerrarRedimensionamento);
      window.removeEventListener(
        "pointercancel",
        this.encerrarRedimensionamento
      );
      if (this.larguraTemporaria === null) return;
      this.usuario_config.stage_palette_width = this.larguraTemporaria;
      this.larguraTemporaria = null;
      document.body.style.cursor = this._cursorAnterior;
      document.body.style.userSelect = this._selecaoAnterior;
    },
    async adicionarEstagioDaBiblioteca(estagioId) {
      const origemId = this.estagioDecisaoOrigemId;
      this.registrarDiagnosticoRete("palette.stage_add_requested", {
        stageType: estagioId,
        sourceNodeId: origemId,
        connectFromDecision: origemId !== null && origemId !== undefined
      });
      this.estagioDecisaoOrigemId = null;
      const posicao = this.usuario_config.use_rete_canvas
        ? this.posicaoInsercaoRete || this.$refs.reteCanvas?.centerPosition()
        : null;
      CadastroFluxo.methods.addNode.call(this, estagioId);
      const novoEstagio =
        this.flowchartDataProperty.nodes[
          this.flowchartDataProperty.nodes.length - 1
        ];
      this.registrarDiagnosticoRete("palette.stage_added", {
        nodeId: novoEstagio?.id,
        stageType: novoEstagio?.chatbot_estagio_id,
        nodeCount: this.flowchartDataProperty.nodes.length,
        linkCount: this.flowchartDataProperty.links.length
      });
      if (posicao) {
        novoEstagio.x = posicao.x - (this.posicaoInsercaoRete ? 0 : 150);
        novoEstagio.y = posicao.y - (this.posicaoInsercaoRete ? 0 : 50);
      }
      if (origemId !== null && origemId !== undefined) {
        try {
          await this.$nextTick();
          await this.$refs.reteCanvas.syncFromScene();
          await this.$refs.reteCanvas.conectarEstagiosRete(
            origemId,
            novoEstagio.id
          );
        } catch (error) {
          this.registrarDiagnosticoRete("palette.connect_failed", {
            sourceNodeId: origemId,
            targetNodeId: novoEstagio?.id,
            stageType: estagioId,
            message: error?.message,
            stack: error?.stack
          });
          console.error("Erro ao conectar novo estágio:", error);
          this.$toast.add({
            severity: "error",
            summary: "Não foi possível conectar o estágio",
            detail: "O estágio foi adicionado, mas o link não pôde ser criado.",
            life: 5000
          });
        }
      }
      this.bibliotecaAberta = false;
    },
    iniciarArrasteEstagio(event, estagioId) {
      event.dataTransfer.effectAllowed = "copy";
      event.dataTransfer.setData(
        "application/x-chatbot-estagio",
        String(estagioId)
      );
      this.arrastandoEstagio = true;
    },
    permitirSoltarEstagio(event) {
      if (this.arrastandoEstagio) event.dataTransfer.dropEffect = "copy";
    },
    soltarEstagio(event) {
      this.arrastandoEstagio = false;
      const estagioId = event.dataTransfer.getData(
        "application/x-chatbot-estagio"
      );
      const estagio = this.estagiosVisiveis.find(
        (item) => String(item.chatbot_estagio_id) === estagioId
      );
      if (!estagio) return;

      if (this.usuario_config.use_rete_canvas) {
        const posicao = this.$refs.reteCanvas?.positionFromEvent(event);
        if (!posicao) return;
        CadastroFluxo.methods.addNode.call(this, estagio.chatbot_estagio_id);
        const node =
          this.flowchartDataProperty.nodes[
            this.flowchartDataProperty.nodes.length - 1
          ];
        node.x = posicao.x - 115;
        node.y = posicao.y - 50;
        this.bibliotecaAberta = false;
        return;
      }
      const flowchart = this.$refs.canvas.querySelector(".flowchart-container");
      if (!flowchart) return;
      const bounds = flowchart.getBoundingClientRect();
      const escala = this.flowchartDataProperty.scale || 1;
      const x =
        (event.clientX -
          bounds.left -
          this.flowchartDataProperty.centerX -
          55) /
        escala;
      const y =
        (event.clientY - bounds.top - this.flowchartDataProperty.centerY - 38) /
        escala;

      CadastroFluxo.methods.addNode.call(this, estagio.chatbot_estagio_id);
      const novoEstagio =
        this.flowchartDataProperty.nodes[
          this.flowchartDataProperty.nodes.length - 1
        ];
      novoEstagio.x = x;
      novoEstagio.y = y;
      this.bibliotecaAberta = false;
    }
  },
  computed: {
    idEstagioBuscaAtivo() {
      if (!this.usuario_config.use_rete_canvas || !this.bibliotecaAberta)
        return null;
      const estagio = this.estagiosVisiveis[this.indiceEstagioBusca];
      return estagio ? `rete-stage-option-${estagio.chatbot_estagio_id}` : null;
    },
    opcoesCamposRete() {
      if (!this.usuario_config.use_rete_canvas) return {};
      return {
        cfe_time: this.times,
        cfe_prioridade: this.prioridades,
        cfe_req_http: this.tipo_req_http,
        tipo_arquivo: this.tipo_arquivo,
        select_orientacao: this.select_orientacao,
        tipo_reagendamento: this.tipo_reagendamento,
        chatbot_formatacao_entrada_id: this.opcoesFormatacaoEntrada.map(
          (item) => ({
            value: item.chatbot_formatacao_entrada_id,
            text: item.cfe_descricao
          })
        ),
        sistema_licenciada_id: this.sistemas.map((item) => ({
          value: item.sistema_licenciada_id,
          text: item.sli_titulo
        })),
        modelo_link_id: this.modeloLinks.map((item) => ({
          value: item.modelo_link_id,
          text: item.sic_descricao
        })),
        chatbot_agenda_id: this.agendas.map((item) => ({
          value: item.id,
          text: item.nome
        })),
        "27:cfe_atributo": this.marcadores,
        "22:cfe_atributo": this.fluxosDeChatbot.map((item) => ({
          value: String(item.chatbot_fluxo_id),
          text: item.cfl_titulo
        })),
        "4:cfe_atributo": [
          { value: null, text: "Não alterar" },
          { value: "resolved", text: "Resolvida" },
          { value: "pending", text: "Pendente" }
        ],
        atributos_customizaveis: this.custom_attributes,
        cfe_inteligencia_artificial: [
          { value: 0, text: "Não" },
          { value: 1, text: "Sim" }
        ],
        tipo_questionario: [
          { value: "SMART", text: "SMART" },
          { value: "PIPEFY", text: "PIPEFY" }
        ],
        tipo_conversao_id: [
          { value: "rtf_to_txt", text: "RTF para Texto Simples" }
        ],
        caixa_entrada: this.possuiRecursoWidgetSite() ? this.caixasEntrada : [],
        cec_parametro: this.variaveisDeclaradas.map((item) => ({
          value: item.text,
          text: item.text
        })),
        cec_operador: [
          { value: "===", text: "Igual" },
          { value: "!==", text: "Diferente" },
          { value: ">", text: "Maior" },
          { value: ">=", text: "Maior ou igual" },
          { value: "<", text: "Menor" },
          { value: "<=", text: "Menor ou igual" }
        ]
      };
    },
    mostrarEstadoRascunho() {
      return Boolean(
        this.rascunhoPronto &&
          (this.rascunhoAlterado || this.rascunhoErro || this.rascunhoSalvoEm)
      );
    },
    estadoRascunho() {
      if (!this.rascunhoPronto) {
        return {
          tipo: "loading",
          icone: "fas fa-circle-notch fa-spin",
          rotulo: "Preparando editor...",
          detalhe: "Verificando alterações guardadas neste navegador"
        };
      }
      if (this.rascunhoErro) {
        return {
          tipo: "error",
          icone: "fas fa-exclamation-circle",
          rotulo: "Rascunho desatualizado",
          detalhe: "Falha ao guardar as alterações neste navegador"
        };
      }
      if (this.rascunhoAlterado) {
        return {
          tipo: "pending",
          icone: "fas fa-circle-notch fa-spin",
          rotulo: "Atualizando rascunho...",
          detalhe: "Alterações ainda não gravadas neste navegador"
        };
      }
      if (this.rascunhoSalvoEm) {
        const data = new Date(this.rascunhoSalvoEm);
        let horario = "";
        if (!Number.isNaN(data.getTime())) {
          const hoje = new Date();
          const mesmoDia = data.toDateString() === hoje.toDateString();
          const dia = mesmoDia
            ? ""
            : ` em ${data.toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit"
              })}`;
          horario = `${dia} às ${data.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit"
          })}`;
        }
        return {
          tipo: "saved",
          icone: "fas fa-check-circle",
          rotulo: `Rascunho atualizado${horario}`,
          detalhe: "Guardado neste navegador · ainda não salvo no sistema"
        };
      }
      return {
        tipo: "empty",
        icone: "far fa-circle",
        rotulo: "Sem alterações pendentes",
        detalhe: "Nenhum rascunho local para este fluxo"
      };
    },
    larguraMinima() {
      if (this.larguraArea < 720) return 155;
      return this.painelTesteAberto ? 180 : 220;
    },
    larguraMaxima() {
      const larguraPainel =
        this.larguraArea < 720
          ? 250
          : this.larguraArea <= 1050
          ? 260
          : this.larguraArea <= 1300
          ? 320
          : 390;
      const espacoCanvas =
        (this.larguraArea < 720 ? 180 : 320) +
        (this.painelTesteAberto ? larguraPainel : 0) +
        (this.sidebarVisible ? larguraPainel : 0);
      return Math.max(
        this.larguraMinima,
        Math.min(400, this.larguraArea - espacoCanvas)
      );
    },
    larguraBiblioteca() {
      const largura =
        this.larguraTemporaria === null
          ? Number(this.usuario_config.stage_palette_width) || 270
          : this.larguraTemporaria;
      return this.limitarLarguraBiblioteca(largura);
    },
    estagiosVisiveis() {
      const termo = this.buscaEstagio
        .toLocaleLowerCase("pt-BR")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const disponiveis = new Set(
        this.chatbotEstagioOpcoes.map((estagio) => estagio.value)
      );
      return this.chatbotEstagios.filter((estagio) => {
        if (!disponiveis.has(estagio.chatbot_estagio_id)) return false;
        if (
          this.usuario_config.stages_by_category &&
          this.chatbot_estagio_categoria_selecionada != null &&
          estagio.ces_categoria != this.chatbot_estagio_categoria_selecionada
        )
          return false;
        return estagio.ces_nome
          .toLocaleLowerCase("pt-BR")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(termo);
      });
    }
  }
};
</script>

<style lang="scss">
.novo-editor {
  --flow-purple: #462181;
  --flow-border: #e7e3ed;
  --flow-ink: #27213a;
  --flow-muted: #78738a;
  background: #fff;
  color: var(--flow-ink);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 57px);
  min-height: 650px;
  margin: -40px -15px 0;
  overflow: hidden;
  font-family: Inter, Arial, sans-serif;
}
.novo-editor button {
  text-transform: none;
}
.novo-editor__header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--flow-border);
  display: flex;
  flex: 0 0 60px;
  gap: 18px;
  padding: 0 16px;
  z-index: 2;
}
.novo-editor__back,
.novo-editor__icon-button {
  align-items: center;
  background: #f6f3fa;
  border: 1px solid var(--flow-border);
  border-radius: 9px;
  color: var(--flow-purple);
  display: inline-flex;
  flex: 0 0 38px;
  height: 38px;
  justify-content: center;
}
.novo-editor__heading {
  min-width: 0;
}
.novo-editor__eyebrow,
.novo-editor__section-kicker,
.novo-editor__toolbar-label {
  color: var(--flow-purple);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
}
.novo-editor__heading h1 {
  font-size: 18px;
  font-weight: 700;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.novo-editor__count {
  background: #f3eefb;
  border-radius: 20px;
  color: var(--flow-purple);
  font-size: 12px;
  font-weight: 700;
  padding: 7px 12px;
  white-space: nowrap;
}
.novo-editor__draft-status {
  align-items: center;
  color: var(--flow-muted);
  display: flex;
  flex: 0 1 auto;
  gap: 8px;
  margin-right: 10px;
  min-width: 0;
}
.novo-editor__draft-status > i {
  color: #aaa3b3;
  flex: 0 0 auto;
  font-size: 15px;
}
.novo-editor__draft-status--saved > i {
  color: #a999bd;
}
.novo-editor__draft-status--error > i {
  color: #bd3851;
}
.novo-editor__draft-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.novo-editor__draft-copy > span {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.novo-editor__draft-copy > small {
  color: var(--flow-muted);
  font-size: 10px;
  line-height: 1.3;
  white-space: nowrap;
}
.novo-editor__header-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.novo-editor__button {
  border: 1px solid var(--flow-border);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 14px;
  white-space: nowrap;
}
.novo-editor__button i {
  margin-right: 6px;
}
.novo-editor__button--quiet {
  background: white;
  color: var(--flow-purple);
}
.novo-editor__button--primary {
  background: var(--flow-purple);
  border-color: var(--flow-purple);
  color: white;
}
.novo-editor__button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.novo-editor__workspace {
  display: flex;
  flex: 1;
  min-height: 0;
  position: relative;
}
.novo-editor__palette {
  --palette-width: 270px;
  background: #fff;
  border-right: 1px solid var(--flow-border);
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  transform: translateX(0);
  transition: transform 0.25s ease, visibility 0s;
  visibility: visible;
  width: var(--palette-width);
  z-index: 3;
}
.novo-editor__palette > :not(.novo-editor__resize-handle) {
  width: var(--palette-width);
}
.novo-editor__palette--closed {
  pointer-events: none;
  transform: translateX(-100%);
  transition: transform 0.25s ease, visibility 0s 0.25s;
  visibility: hidden;
}
.novo-editor__resize-handle {
  align-items: center;
  bottom: 0;
  cursor: col-resize;
  display: flex;
  justify-content: center;
  outline: none;
  position: absolute;
  right: 0;
  top: 0;
  touch-action: none;
  width: 12px;
  z-index: 5;
}
.novo-editor__resize-handle span {
  background: #c8b8dd;
  border-radius: 5px;
  height: 46px;
  width: 4px;
}
.novo-editor__resize-handle:hover span,
.novo-editor__resize-handle:focus span {
  background: var(--flow-purple);
}
.novo-editor__palette-head {
  padding: 14px;
}
.novo-editor__palette-title {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.novo-editor__palette-title button {
  align-items: center;
  background: #f7f4fa;
  border: 0;
  border-radius: 7px;
  color: var(--flow-purple);
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}
.novo-editor__palette-head h2 {
  font-size: 17px;
  font-weight: 700;
  margin: 5px 0;
}
.novo-editor__palette-head p {
  color: var(--flow-muted);
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
}
.novo-editor__palette-filters {
  display: grid;
  gap: 9px;
  padding: 0 15px 14px;
}
.novo-editor__search {
  align-items: center;
  border: 1px solid var(--flow-border);
  border-radius: 8px;
  color: var(--flow-muted);
  display: flex;
  gap: 8px;
  margin: 0;
  padding: 0 11px;
}
.novo-editor__search input {
  border: 0;
  min-width: 0;
  outline: 0;
  padding: 10px 0;
  width: 100%;
}
.novo-editor__category-select.p-dropdown {
  align-items: center;
  background: #fbfafc;
  border-color: var(--flow-border);
  border-radius: 8px;
  font-size: 12px;
  min-height: 38px;
  width: 100%;
}
.novo-editor__category-select.p-dropdown.p-focus {
  border-color: #8c68ba;
  box-shadow: 0 0 0 3px rgba(70, 33, 129, 0.12);
}
.novo-editor__category-select .p-dropdown-label {
  color: #453c55;
  font-size: 12px;
  padding: 9px 10px;
}
.novo-editor__stage-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 10px 12px;
}
.novo-editor__stage {
  align-items: center;
  background: #fff;
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--flow-ink);
  display: flex;
  font-size: 12px;
  gap: 10px;
  margin-bottom: 3px;
  padding: 11px 8px;
  text-align: left;
  width: 100%;
  cursor: grab;
  user-select: none;
}
.novo-editor__stage:active {
  cursor: grabbing;
}
.novo-editor__stage:hover,
.novo-editor__stage:focus {
  background: #f7f3fb;
  border-color: #e4d8f4;
}
.novo-editor--rete-canvas .novo-editor__stage--highlighted {
  background: #eee6f8;
  border-color: #bba1d6;
  box-shadow: inset 3px 0 #8055ad;
  color: #57317d;
}
.novo-editor__stage span:nth-child(2) {
  flex: 1;
}
.novo-editor__stage i {
  color: var(--flow-purple);
  font-size: 11px;
}
.novo-editor__stage-mark {
  border-radius: 4px;
  flex: 0 0 8px;
  height: 24px;
}
.novo-editor__empty-list {
  color: var(--flow-muted);
  font-size: 12px;
  padding: 12px;
}
.novo-editor__palette-footer {
  border-top: 1px solid var(--flow-border);
  display: grid;
  gap: 3px;
  padding: 12px;
}
.novo-editor__palette-footer button {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--flow-purple);
  font-size: 12px;
  font-weight: 700;
  padding: 9px;
  text-align: left;
}
.novo-editor__palette-footer button:hover {
  background: #f7f3fb;
}
.novo-editor__palette-footer i {
  margin-right: 8px;
}
.novo-editor__main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.novo-editor__details {
  align-items: end;
  border-bottom: 1px solid var(--flow-border);
  display: flex;
  gap: 12px;
  padding: 12px 14px;
}
.novo-editor__field {
  min-width: 0;
}
.novo-editor__field--title {
  flex: 0 1 220px;
}
.novo-editor__field--description {
  flex: 1 1 260px;
}
.novo-editor__field--category {
  flex: 0 1 205px;
}
.novo-editor__field label {
  color: #5f586c;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin: 0 0 5px;
}
.novo-editor__field .form-control,
.novo-editor__field .p-multiselect {
  border-color: var(--flow-border);
  border-radius: 8px;
  font-size: 12px;
  height: 37px;
  width: 100%;
}
.novo-editor__flow-categories .p-multiselect-label {
  align-items: center;
  display: flex;
  gap: 4px;
  overflow: auto;
  padding: 5px 8px;
  white-space: nowrap;
}
.novo-editor__flow-categories .p-multiselect-token {
  background: #efe8f8;
  border-radius: 5px;
  color: #462181;
  font-size: 11px;
  margin: 0;
  padding: 3px 6px;
}
.novo-editor__flow-categories.p-focus {
  border-color: #8c68ba;
  box-shadow: 0 0 0 3px rgba(70, 33, 129, 0.12);
}
.novo-editor__icon-button {
  margin-bottom: 0;
}
.novo-editor__toolbar {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--flow-border);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  min-height: 48px;
  padding: 5px 12px;
}
.novo-editor__toolbar-group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}
.novo-editor__toolbar-label {
  margin: 0 10px 0 3px;
}
.novo-editor__toolbar-group button {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 7px;
  color: #5b526a;
  font-size: 12px;
  font-weight: 600;
  min-height: 34px;
  padding: 7px 9px;
}
.novo-editor__toolbar-group button:hover,
.novo-editor__toolbar-group button:focus {
  background: #f5f0fa;
  border-color: #e6d9f2;
  color: var(--flow-purple);
}
.novo-editor__toolbar-group button.novo-editor__tool-button--active {
  background: #f1eafa;
  border-color: #d9c8ed;
  color: var(--flow-purple);
}
.novo-editor__toolbar-group button.novo-editor__tool-button--active i {
  color: var(--flow-purple);
}
.novo-editor__toolbar-group .novo-editor__toolbar-icon i {
  margin-right: 0;
}
.novo-editor__toolbar-group .novo-editor__test-trigger {
  background: #f1eafa;
  border-color: #e0d0f0;
  color: #462181;
  font-weight: 700;
  margin-right: 8px;
}
.novo-editor__toolbar-group .novo-editor__test-trigger:hover {
  background: #e9dcf8;
}
.novo-editor__toolbar-group button i {
  color: var(--flow-purple);
  margin-right: 5px;
}
.novo-editor__toolbar-group--end button i {
  margin-right: 0;
}
.novo-editor__editor-body {
  --test-width: 390px;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
}
.novo-editor__editor-body--testing .novo-editor__palette {
  left: var(--test-width);
}
.novo-editor__editor-body--testing .novo-editor__open-palette {
  left: calc(var(--test-width) + 16px);
}
.novo-editor__canvas {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
}
.novo-editor__canvas--selection-mode {
  cursor: default !important;
}
.novo-editor__canvas--selection-mode,
.novo-editor__canvas--selection-mode * {
  cursor: default !important;
}
.novo-editor__selection-box {
  background: rgba(91, 48, 151, 0.12);
  border: 1px solid #754bb2;
  border-radius: 3px;
  pointer-events: none;
  position: absolute;
  z-index: 5;
}
.novo-editor__open-palette {
  align-items: center;
  background: #fff;
  border: 1px solid #e9e1f1;
  border-radius: 999px;
  box-shadow: 0 10px 30px rgba(44, 25, 69, 0.18);
  color: #462181;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 10px;
  left: 16px;
  padding: 5px 14px 5px 5px;
  position: absolute;
  top: 16px;
  z-index: 3;
}
.novo-editor__open-palette:hover,
.novo-editor__open-palette:focus {
  border-color: #c6b3df;
  box-shadow: 0 13px 32px rgba(44, 25, 69, 0.23);
  color: #462181;
  transform: translateY(-2px);
}
.novo-editor__open-palette-icon {
  align-items: center;
  background: var(--flow-purple);
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}
.novo-editor__open-palette-chevron {
  color: #9b8aae;
  font-size: 10px;
  margin-left: 4px;
}
.novo-editor__test-panel {
  background: #fff;
  border-right: 1px solid var(--flow-border);
  bottom: 0;
  height: 100%;
  left: 0;
  min-height: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: var(--test-width);
  z-index: 4;
}
.novo-editor__chat-slot {
  background: #faf9fc;
  display: flex;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.novo-editor__chat-placeholder {
  align-items: center;
  color: var(--flow-muted);
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 12px;
  gap: 10px;
  justify-content: center;
  padding: 20px;
  text-align: center;
  position: absolute;
  inset: 0;
  z-index: 1;
  background: #faf9fc;
}
.novo-editor__chat-placeholder i {
  color: #b9a6d2;
  font-size: 26px;
}
.novo-editor__canvas .flowchart-container {
  background-color: #faf9fc !important;
  background-image: radial-gradient(#d8d3e1 1px, transparent 1px) !important;
  background-size: 22px 22px !important;
  height: 100%;
  width: 100%;
}
.novo-editor__canvas--drop .flowchart-container {
  background-color: #f4effa !important;
}
.novo-editor__drop-hint {
  background: #fff;
  border: 1px solid #ceb9e9;
  border-radius: 8px;
  box-shadow: 0 5px 18px rgba(70, 33, 129, 0.12);
  color: var(--flow-purple);
  font-size: 12px;
  font-weight: 700;
  left: 50%;
  padding: 9px 14px;
  pointer-events: none;
  position: absolute;
  top: 18px;
  transform: translateX(-50%);
  z-index: 2;
}
.novo-editor__canvas .flowchart-container svg {
  height: 100% !important;
}
.novo-editor__canvas-hint {
  align-items: center;
  background: white;
  border: 1px solid #ece5f4;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(70, 33, 129, 0.08);
  color: var(--flow-muted);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  gap: 6px;
  left: 50%;
  padding: 17px 26px;
  pointer-events: none;
  position: absolute;
  top: 38%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.novo-editor__canvas-hint i {
  color: var(--flow-purple);
  font-size: 22px;
}
.novo-editor__canvas-hint strong {
  color: var(--flow-ink);
  font-size: 14px;
}
.novo-editor .flowchart-node {
  border-radius: 9px !important;
  box-shadow: 0 4px 14px rgba(42, 30, 66, 0.13);
  min-height: 75px;
  padding: 7px;
  width: 110px;
}
.novo-editor .flowchart-node .node-label {
  font-size: 12px !important;
}
.novo-editor .flowchart-node .node-type {
  display: none !important;
}
.novo-editor .flowchart-node.selected {
  box-shadow: 0 0 0 3px var(--flow-purple), 0 6px 18px rgba(42, 30, 66, 0.18);
}
.novo-editor .flowchart-node.node-group-selected {
  box-shadow: 0 0 0 2px #8d6bc0, 0 6px 18px rgba(42, 30, 66, 0.18);
}
.novo-editor--rete-canvas .sidebar-container--modern {
  background: #fff;
  border: 1px solid #e9e3ef;
  border-radius: 14px;
  box-shadow: 0 16px 46px rgba(40, 25, 62, 0.2);
  flex: none;
  max-height: calc(100% - 24px);
  max-width: min(420px, calc(100% - 24px));
  min-width: 300px;
  overflow: auto !important;
  position: absolute;
  width: 420px;
  z-index: 8;
  .sidebar-header {
    align-items: center;
    background: #fff;
    padding: 18px 20px;
  }
  .sidebar-eyebrow {
    color: #897b9a;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.09em;
  }
  .sidebar-title {
    color: #30283c;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin: 4px 0 0;
  }
  .fluxo-inputs-container {
    padding: 18px 20px 24px;
  }
  .text-title {
    color: #696174;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.45;
  }
  .form-control,
  .p-dropdown,
  .p-multiselect {
    border-color: #e3deea;
    border-radius: 8px;
    min-height: 38px;
  }
  .tomar-decisao-item {
    background: #fbfaff;
    border: 1px solid #ece7f3;
    border-left: 3px solid #8f6bb7;
    border-radius: 10px;
    margin: 12px 0;
    padding: 13px 13px 4px;
    h6 {
      color: #4a365f;
      font-size: 12px;
      font-weight: 750;
      margin: 0 0 12px;
    }
    hr {
      border-color: #eeeaf3;
      margin: 14px -3px 8px;
    }
  }
}
.novo-editor:fullscreen {
  height: 100vh;
  margin: 0;
}
@media (max-width: 1300px) {
  .novo-editor__editor-body {
    --test-width: 320px;
  }
  .novo-editor .sidebar-container.sidebar-container--embedded {
    flex-basis: 320px;
    min-width: 280px;
    width: 320px;
  }
  .novo-editor__details {
    flex-wrap: wrap;
  }
  .novo-editor__field--title,
  .novo-editor__field--description,
  .novo-editor__field--category {
    flex: 1 1 180px;
  }
  .novo-editor--rete-canvas .sidebar-container--modern {
    flex-basis: 300px;
    min-width: 300px;
    width: 300px;
  }
}
@media (max-width: 1050px) {
  .novo-editor__draft-copy > small {
    display: none;
  }
  .novo-editor__editor-body {
    --test-width: 260px;
  }
  .novo-editor .sidebar-container.sidebar-container--embedded {
    flex-basis: 260px;
    min-width: 260px;
    width: 260px;
  }
}
@media (max-width: 720px) {
  .novo-editor {
    height: calc(100vh - 46px);
    margin: -24px -15px 0;
    min-height: 570px;
  }
  .novo-editor__header {
    gap: 9px;
    padding: 0 10px;
  }
  .novo-editor__header--with-draft {
    align-content: center;
    flex-basis: 92px;
    flex-wrap: wrap;
  }
  .novo-editor__header--with-draft .novo-editor__header-actions {
    justify-content: flex-end;
    margin-left: 0;
    order: 4;
    width: 100%;
  }
  .novo-editor__heading {
    flex: 1;
  }
  .novo-editor__draft-status {
    margin-right: auto;
  }
  .novo-editor__draft-status > i {
    font-size: 12px;
  }
  .novo-editor__draft-copy > span {
    font-size: 11px;
  }
  .novo-editor__count,
  .novo-editor__button--quiet span {
    display: none;
  }
  .novo-editor__button {
    padding: 8px;
  }
  .novo-editor__editor-body {
    --test-width: 250px;
  }
  .novo-editor .sidebar-container.sidebar-container--embedded {
    flex-basis: 250px;
    min-width: 250px;
    width: 250px;
  }
  .novo-editor__palette-head,
  .novo-editor__palette-filters {
    padding-left: 8px;
    padding-right: 8px;
  }
  .novo-editor__stage {
    font-size: 11px;
  }
  .novo-editor__details {
    padding: 8px;
  }
  .novo-editor__field--description {
    display: none;
  }
}
</style>
